import { render, staticRenderFns } from "./chooseDialog.vue?vue&type=template&id=b00cd96e&scoped=true&"
import script from "./chooseDialog.vue?vue&type=script&lang=js&"
export * from "./chooseDialog.vue?vue&type=script&lang=js&"
import style0 from "./chooseDialog.vue?vue&type=style&index=0&id=b00cd96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00cd96e",
  null
  
)

export default component.exports